import "./bootstrap";
import "../sass/app.scss";

// import Swiper JS
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

// import Swiper styles
import "swiper/swiper-bundle.css";

document.addEventListener("DOMContentLoaded", function () {
    const isMobile = /Mobi|Android|iPhone/.test(navigator.userAgent);

    ///////////////
    //////// HEADER HOME
    ///////////////

    if (window.innerWidth > 750) {
        // Get the header element
        const headerHome = document.querySelector(".home .header");

        if (headerHome !== null) {
            // Store the initial position of the headerHome
            const initialTop = headerHome.offsetTop;

            // Listen for the scroll event
            window.addEventListener("scroll", function () {
                // Check if the window's scroll position is greater than the headerHome's initial position
                if (window.scrollY > initialTop) {
                    // If so, set the headerHome's position to fixed
                    headerHome.style.position = "fixed";
                    headerHome.style.top = "0";
                } else {
                    // Otherwise, reset the headerHome's position to static
                    headerHome.style.position = "absolute";
                    headerHome.style.top = "calc(50vh - 45px)";
                }
            });
        }
    }

    ///////////////
    ////// SHOWREEL
    ///////////////

    const children = document.querySelectorAll(
        ".home__showreel > :not(header)"
    );

    let currentIndex = 0;

    function updateZIndex() {
        if (currentIndex < children.length) {
            const currentZIndex =
                parseInt(getComputedStyle(children[currentIndex]).zIndex) || 0;

            children[currentIndex].style.zIndex = currentZIndex + 1;

            currentIndex++;
        } else {
            currentIndex = 0;
        }
    }
    setInterval(updateZIndex, 1000);

    //////////////
    // ARTIST LIST
    //////////////

    const artistElements = document.querySelectorAll(".home__artists__artist");

    const imgElements = document.querySelectorAll(".home__artists__imgs__img");

    // Function to check if an element's vertical center is near the viewport's vertical center
    function isCentered(element) {
        const rect = element.getBoundingClientRect();
        const centerY = window.innerHeight / 2;
        const elementCenterY = rect.top + rect.height / 2 + 20;
        return Math.abs(centerY - elementCenterY) < 13;
    }

    artistElements.forEach((artist, index) => {
        artist.addEventListener("mouseover", () => {
            imgElements[index].style.opacity = "1";
        });
        artist.addEventListener("mouseout", () => {
            imgElements[index].style.opacity = "0";
        });
    });

    if (window.innerWidth <= 750) {
        // Assuming 768px as the breakpoint for mobile
        window.addEventListener("scroll", () => {
            artistElements.forEach((artist, index) => {
                if (isCentered(artist)) {
                    imgElements[index].style.opacity = "1";
                    artist.classList.remove("home__artists__artist--faded"); // Set the opacity of the centered artist name to full
                } else {
                    imgElements[index].style.opacity = "0";
                    artist.classList.add("home__artists__artist--faded"); // Fade out the opacity of non-centered artist names
                }
            });
        });
    }

    ///////////////
    ///// ADJUST ARTIST TITLE
    ///////////////

    const title = document.querySelector(".artist__title");

    if (title !== null) {
        function adjustFontSize() {
            // Get the current width of the title and the screen width
            const titleWidth = title.offsetWidth;
            const screenWidth = window.innerWidth - 64;

            // Calculate the multiplier factor
            const multiplier = screenWidth / titleWidth;

            // Get the current font size of the title
            const currentFontSize = parseFloat(
                window.getComputedStyle(title).fontSize
            );

            // Calculate the new font size
            let newFontSize = currentFontSize * multiplier; // Subtracting 4rem (assuming 16px as the default browser font size)

            if (newFontSize > 250) {
                newFontSize = 250;
            }

            // Apply the new font size to the title
            title.style.fontSize = newFontSize + "px";
        }

        setTimeout(() => {
            adjustFontSize();
        }, 100);

        window.addEventListener("resize", adjustFontSize);
    }

    ///////////////
    ///// SWIPERS
    ///////////////

    const swipers = new Swiper(".swiper-container", {
        modules: [Navigation],
        navigation: {
            nextEl: ".swiper-navigation-next",
            prevEl: ".swiper-navigation-prev",
        },
        spaceBetween: 10,
        slidesPerView: "auto",
    });

    ///////////////
    ////// LOGOS MARQUEE
    ///////////////

    const logoContainer = document.querySelector(
        ".wp-block-create-block-logos"
    );
    const logos = document.querySelector(".logos");

    if (logos !== null) {
        for (let i = 0; i < 3; i++) {
            const clone = logos.cloneNode(true);
            logoContainer.appendChild(clone);
        }

        const logoCount = logoContainer.querySelectorAll("img").length;

        let baseDuration = 1; // Adjust this value as needed

        if (window.innerWidth < 750) {
            baseDuration = 0.3;
        }

        const totalDuration = baseDuration * logoCount;

        logoContainer.style.animation = `marquee ${totalDuration}s linear infinite`;
    }

    ////////////////
    /////// BOOKING ARTIST COVER DYNAMIC
    ////////////////

    const bookingCover = document.querySelector(".booking__cover");
    const artistSelector = document.getElementById("artistSelector");

    // Function to extract slug from "pretty" URL
    function getSlugFromPrettyUrl() {
        const pathArray = window.location.pathname.split("/");
        // Assuming the slug is the last part of the URL
        return pathArray[pathArray.length - 1];
    }

    // Function to set the cover image based on the selected artist
    function setCoverImageForSelectedArtist() {
        const selectedOption =
            artistSelector.options[artistSelector.selectedIndex];
        if (selectedOption) {
            bookingCover.style.backgroundImage = `url(${selectedOption.value})`;
            bookingCover.style.height = "25vw"; // Set an appropriate height if needed
        }
    }

    // 1. Try to get the slug from the URL parameter first
    const urlParams = new URLSearchParams(window.location.search);
    let slugFromUrl = urlParams.get("artist"); // For custom URL parameter

    // 2. If not found, try to get it from the "pretty" URL
    if (!slugFromUrl && bookingCover && artistSelector) {
        slugFromUrl = getSlugFromPrettyUrl();
        const firstOptionValue = document.querySelector(
            "#artistSelector option"
        ).value;
        bookingCover.style.backgroundImage = "url('" + firstOptionValue + "')";
        bookingCover.style.height = "25vw";
    }

    // 3. Match the slug with the data-slug attribute of the options and set the cover image
    if (bookingCover && artistSelector) {
        for (let option of artistSelector.options) {
            if (option.getAttribute("data-slug") === slugFromUrl) {
                // Set the image of .booking__cover
                bookingCover.style.backgroundImage = `url(${option.value})`;
                bookingCover.style.height = "25vw"; // Set an appropriate height if needed
                artistSelector.value = option.value; // Set the select input to the matching artist
                break;
            }
        }
        // 4. Add event listener to change the cover image when a new artist is selected
        artistSelector.addEventListener(
            "change",
            setCoverImageForSelectedArtist
        );
    }

    ////////////////
    /////// BURGER
    ////////////////

    const header = document.querySelector(".header");
    const burger = document.querySelector(".header__burger");
    const headerBg = document.querySelector(".header__bg");

    burger.addEventListener("click", () => {
        header.classList.toggle("header--open");
        headerBg.classList.toggle("header__bg--on");
    });

    ////////////////
    ////////// Intro fix
    ///////////////

    // Get the element you want to modify
    const elementToFix = document.querySelector(".home__artists__content"); // Replace with your element's selector
    const elementToFixParent = document.querySelector(".home__artists"); // Replace with your element's selector

    if (elementToFix !== null) {
        // Function to check the element's position and update its style
        function checkPositionAndFixElement() {
            const parentFromTop =
                elementToFixParent.getBoundingClientRect().top;

            console.log(parentFromTop);

            if (parentFromTop <= 0) {
                // When the element is 50px or less from the top, make it fixed
                elementToFix.style.position = "fixed";
                elementToFix.style.top = "5rem"; // Adjust as needed
            } else {
                // When the element is more than 50px from the top, revert to absolute
                elementToFix.style.position = "absolute";
                // Reset the top value to what it was initially, or adjust as needed
                elementToFix.style.top = "5rem";
            }
        }

        // Listen for the scroll event on the window
        if (!isMobile) {
            window.addEventListener("scroll", checkPositionAndFixElement);
        }
    }

    ////////////////////
    ///// ARTIST FOOTER OVERLAP FIX
    ////////////////////

    // Function to check if two elements overlap
    function isOverlapping(elem1, elem2) {
        const rect1 = elem1.getBoundingClientRect();
        const rect2 = elem2.getBoundingClientRect();

        return !(
            rect1.top > rect2.bottom ||
            rect1.right < rect2.left ||
            rect1.bottom < rect2.top ||
            rect1.left > rect2.right
        );
    }

    // Function to update the position of the .artist__footer element
    function updateFooterPosition() {
        if (!isMobile) {
            const artistFooter = document.querySelector(".artist__footer");
            // Selecting the last paragraph in the .wp-block-column
            const wpBlockParagraphs =
                document.querySelectorAll(".wp-block-column p");
            const lastParagraph =
                wpBlockParagraphs[wpBlockParagraphs.length - 1];

            if (artistFooter && lastParagraph) {
                if (isOverlapping(artistFooter, lastParagraph)) {
                    artistFooter.style.position = "relative";
                    artistFooter.style.margin = "2rem 0 0 0";
                } else {
                    artistFooter.style.position = "absolute";
                }
            }
        }
    }

    // Run the function initially and on window resize
    updateFooterPosition();
    window.addEventListener("resize", updateFooterPosition);

    /////////////////////
    //////////  BOOKING FORM
    /////////////////////

    function artistFormSelector() {
        const selectedOption = artistSelector.options[artistSelector.selectedIndex];
        const optionContent = selectedOption.innerHTML;
        document.getElementById("artistCover").value = optionContent;
    }

    artistSelector.addEventListener("change", function () {
        artistFormSelector();
    });

    artistFormSelector();

    var form = document.getElementById("bookingForm");
    var responseDiv = document.getElementById("formResponse");

    form.onsubmit = function (event) {
        event.preventDefault();

        var formData = new FormData(form);
        formData.append("action", "send_booking_request"); // Action parameter

        var xhr = new XMLHttpRequest();
        xhr.open("POST", "/wp/wp-admin/admin-ajax.php", true); // WordPress AJAX handler

        xhr.onload = function () {
            if (xhr.status === 200) {
                responseDiv.innerHTML = xhr.responseText;
            } else {
                testæ;
                responseDiv.innerHTML =
                    "Request failed. Returned status of " + xhr.status;
            }
        };

        xhr.send(formData);

        return false;
    };
    /// end of app.js
});
